import { NgClass } from '@angular/common';
import { Component, Input, OnChanges } from '@angular/core';
import { ControlContainer, FormsModule, NgForm } from '@angular/forms';
import { OffClickModule } from '@df/module-off-click/off-click.module';
import { OrderByPipe } from '@df/ui/common/order-by.pipe';
import { ValidatePatternDirective } from '@df/ui/form/validate-pattern.directive';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { MuiInputDirective } from '../../../module/legacy/forms/mui-input.directive';
import { AbstractAccountAddressFieldsetComponent } from '../../../ui/form/abstract-address-fieldset.component';
import { InputWrapBodyDirective } from '../../../ui/form/input-wrap-body.directive';
import { InputWrapComponent } from '../../../ui/form/input-wrap.component';
declare module '@df/session/api/address-book/address' {
    interface IAddressData {
        nickname?: string;
    }
}
@Component({
    selector: 'account-address-fieldset',
    templateUrl: './account-address-fieldset.html',
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
    standalone: true,
    imports: [TranslationModule, FormsModule, NgClass, InputWrapComponent, MuiInputDirective, OrderByPipe, OffClickModule, InputWrapBodyDirective, ValidatePatternDirective]
})
export class AccountAddressFieldsetComponent extends AbstractAccountAddressFieldsetComponent implements OnChanges {
    @Input()
    isInEditor?: boolean;
}
